import "./App.css";
import AppRouters from "./Router";

function App() {
  return <AppRouters />;
}
export default App;
